import LoadingIndicator from '../../../components/Global/loading-indicator/loading-indicator';
import { useState, useEffect } from 'react';
import {
  Card,
  CardActions,
  CardContent,
  Typography,
  Button,
  Box,
  Grid,
  TextField,
  Autocomplete,
  Tooltip,
  FormControlLabel,
  Checkbox,
  Chip,
  IconButton,
  List,
  ListItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import TwitterIcon from '@mui/icons-material/Twitter';
import CloseIcon from '@mui/icons-material/Close';
import { ConfirmationModal, SocialPostModal } from '../../../components/Modals/SocialMedia';
import { useUser } from '../../../context/UserContext';
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  DeleteMessages,
  GetSocialCategories,
  GetSocialMediaFileList,
  PatchMessage,
  UpdateMessages,
} from '../../../api/marketing';
import useForm from '../../AdminContentMgt/Components/useForm';
import { GetProductNames } from '../../../api/product';
import { GetAllCasgUsers } from '../../../api/agencyadmin';
import { Dropdown, MultipleSelect } from '../../../components/Inputs/Dropdown/Dropdown';
import { CardMedia } from '@mui/material';
import DownloadSharpIcon from '@mui/icons-material/DownloadSharp';
import './PostsList.scss';
import LinkedInShareButton from './LinkedInShareButton';
import FacebookButton from './FacebookButton.jsx';
import NotificationSnackbar from '../../../components/Global/NotificationSnackbar/NotificationSnackbar';
import InstagramShareButton from './InstagramShareButton';
import TwitterShareButton from './TwitterShareButton';
import { useStore } from '../../../store/pages/forms/store';
import AddImage from '../../../components/Images/Icons/AddImageIcon.js';
import { ImageTile } from '../../../components/Images/ImageTile/ImageTile.jsx';
import UpdateImage from '../../../components/Images/Icons/UpdateImage.js';
import CopyToClipboard from 'react-copy-to-clipboard';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { GetFile as GetImage } from '../../../api/pdfdownload.js';
import {
  base64ToBlob,
  blobToDownloadableUrl,
} from '../../../components/Utilities/HelperMethods.js';

const PAGE_ID = '351966495437374';
export const PostsList = ({ published, isAdminPage = false }) => {
  const [open, setOpen] = useState();
  const [imageData, setImageData] = useState(new Map());
  const [showTooltip, setShowTooltip] = useState(false);
  const [resetFlag, setResetFlag] = useState(false);
  const [openImageModal, setOpenImagemodal] = useState();
  const [showSocialPost, setShowSocialPost] = useState(false);
  const [messagez, setMessagez] = useState();
  const [confirmed, setConfirmed] = useState(false);
  const [showConfirmed, setShowConfirmed] = useState(false);
  const setNotificationData = useStore((state) => state.SHOW_NOTIFICATION);
  const notificationData = useStore((state) => state.notificationData);
  const setApprovedMessages = useStore((state) => state.SET_APPROVED_MESSAGES);
  const approvedMessages = useStore((state) => state.approvedMessages);
  const setDraftMessages = useStore((state) => state.SET_DRAFT_MESSAGES);
  const draftMessages = useStore((state) => state.draftMessages);
  const user = useUser();
  const isContentManager = user.permissions.ContentManagement === true;
  const expiresDate = localStorage.getItem('linkedinTokenExpires');
  const linkedinTokenFlag = new Date() < new Date(expiresDate);

  useEffect(() => {
    if (published) {
      setMessagez(approvedMessages);
    } else {
      setMessagez(draftMessages);
    }
  }, [approvedMessages, draftMessages]);

  useEffect(() => {
    messagez?.forEach((m) => {
      const { postsMedia } = m;
      const image = postsMedia[0]?.image;
      const imagePath = image?.url;
      const data = imageData.get(imagePath);
      if (imagePath && !data) {
        const ext = imagePath.substring(imagePath.lastIndexOf('.') + 1);
        const getImageData = async () => {
          try {
            const i = await GetImage(`AgentPortal\\SocialMedia${imagePath}`)();
            imageData.set(imagePath, i);
            setImageData(imageData);
          } catch (e) {
            console.log(e);
          }
        };
        getImageData();
      }
    });
  }, [messagez, imageData]);

  const patchMessage = useMutation({
    mutationFn: async (data) => {
      return await PatchMessage(data, data?.queries)();
    },
  });

  if (messagez?.length === 0) {
    return 'No messages have been created for the selected category';
  }

  const resetImageOnPage = (variables, data) => {
    if (published) {
      const index = approvedMessages?.findIndex((m) => m.id === variables.postsMedia[0].PostId);
      approvedMessages[index].postsMedia = data.postsMedia;
      setApprovedMessages(approvedMessages);
    } else {
      if (variables?.postsMedia?.length > 0) {
        const index = draftMessages?.findIndex((m) => m.id === variables.postsMedia[0].PostId);
        draftMessages[index].postsMedia = data.postsMedia;
        setDraftMessages(draftMessages);
      }
    }
  };

  const showPostDetail = (m) => {
    setOpen({ ...m, imageData });
  };

  const showImagesModal = (m) => {
    setOpenImagemodal(m);
  };

  const ValueCopied = () => (
    <div className="value-copied hover-overlay-text">Copied to clipboard!</div>
  );

  const downloadFile = (url, fileName) => {
    const aElement = document.createElement('a');
    aElement.href = url;
    aElement.download = fileName;
    document.body.appendChild(aElement);
    aElement.click();
    document.body.removeChild(aElement);
  };

  return (
    <Grid
      size={{
        xs: 12,
        sm: 6,
      }}
    >
      <PostDetailsModal
        show={open}
        setShow={setOpen}
        setStatus={setNotificationData}
        confirmed={confirmed}
        setConfirmed={setConfirmed}
        setShowConfirmModal={setShowConfirmed}
        published={published}
        messages={messagez}
        patchMessage={patchMessage}
        resetFlag={resetFlag}
        setResetFlag={setResetFlag}
        showImagesModal={showImagesModal}
      />
      <ConfirmationModal
        message={'Are you sure you want to complete this item?'}
        showConfirmed={showConfirmed}
        setConfirmed={setConfirmed}
        setShowConfirmed={setShowConfirmed}
      />
      <SocialPostModal
        show={showSocialPost}
        setShow={setShowSocialPost}
        setStatus={setNotificationData}
      />
      <UpdateImageModal
        updateImage={patchMessage}
        show={openImageModal}
        setShow={setOpenImagemodal}
        setStatus={setNotificationData}
        confirmed={confirmed}
        setConfirmed={setConfirmed}
        resetFlag={resetFlag}
        setResetFlag={setResetFlag}
        setShowConfirmModal={setShowConfirmed}
      />
      <NotificationSnackbar
        status={notificationData?.status}
        openTrigger={notificationData?.show}
        onClose={(event, reason) => {
          if (reason === 'clickaway') {
            return;
          }
          notificationData['show'] = false;
          setNotificationData(notificationData);
        }}
        successMsg={notificationData?.successMsg}
        errorMsg={notificationData?.errorMsg}
      />
      <Box
        sx={{
          maxWidth: '100%',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-evenly',
          alignContent: 'space-around',
          flexWrap: 'wrap',
          p: 1,
          m: 1,
          bgcolor: 'background.paper',
          // height: 200,
          borderRadius: 1,
        }}
      >
        {messagez?.map((m, index) => {
          const { message, title, network, productID, postsMedia } = m;
          const image = postsMedia[0]?.image;
          const imagePath = image?.url;
          const imageBaseUrl = process.env.REACT_APP_EXTHUB_DOMAIN;

          return (
            <>
              <Card
                key={`${m.title}${index}`}
                sx={{
                  minWidth: 300,
                  height: 320,
                  marginTop: 2,
                  maxWidth: 300,
                  display: 'flex',
                  flexDirection: 'column',
                  position: 'relative',
                }}
              >
                <CardContent>
                  <Typography
                    sx={{
                      display: 'flex',
                      width: '300px',
                      margin: '-16px 0 10px -16px',
                      padding: '15px',
                      fontSize: 17.5,
                      color: 'white',
                      justifyContent: 'flex-start',
                      backgroundColor: '#0075BF',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {limitStringWithEllipsis(title, 30)}
                  </Typography>

                  <div
                    className="info-copy hover-overlay-item"
                    style={{ /*height: '65px',*/ maxHeight: '100px', overflow: 'auto' }}
                  >
                    {showTooltip === false || showTooltip !== message ? (
                      <Typography variant="body2">
                        {message}
                        <br />
                      </Typography>
                    ) : (
                      <ValueCopied />
                    )}
                  </div>
                  {image?.url && (
                    <div>
                      <CardMedia
                        className="link-feel"
                        image={`${imageBaseUrl}/api/cdn${image.url}`}
                        title={title}
                        style={{
                          height: 120,
                          // paddingBottom: '56.25%', // 16:9,
                          marginTop: '20px',
                        }} // specify styles
                      />
                    </div>
                  )}
                  {isContentManager && m?.network && !image?.url && (
                    <Tooltip title={message}>
                      <IconButton
                        onClick={() => showImagesModal(m)}
                        className="link-feel"
                        style={{
                          width: '40px',
                          height: '40px',
                          position: 'absolute',
                          bottom: '30px',
                          right: '0px',
                          fill: '#ADD8E6',
                          outline: 'none',
                        }}
                      >
                        <AddImage />
                      </IconButton>
                    </Tooltip>
                  )}
                </CardContent>
                <Typography
                  sx={{ position: 'absolute', bottom: '8px', left: '5px' }}
                  color="text.secondary"
                >
                  {productID}
                </Typography>
                <CardActions
                  disableSpacing
                  sx={{
                    mt: 'auto',
                    position: 'absolute',
                    bottom: '0px',
                    right: '0px',
                  }}
                >
                  {
                    <div>
                      {image?.url && (
                        <Tooltip title="Download image">
                          <DownloadSharpIcon
                            className="link-feel"
                            fontSize="small"
                            onClick={async () => {
                              postsMedia.forEach(async (pm, i) => {
                                const imp = pm?.image?.url;
                                const ext = imp.substring(imp.lastIndexOf('.') + 1);
                                let network = '';
                                if (pm?.image?.network) {
                                  network = '_' + pm?.image?.network;
                                }
                                const fileName =
                                  imp.substring(imp.lastIndexOf('/') + 1) + '_' + i + network;
                                const blob = await base64ToBlob(imageData.get(imagePath), {
                                  type: `image/${ext}`,
                                });
                                const url = blobToDownloadableUrl(blob);
                                downloadFile(url, fileName);
                              });
                            }}
                          />
                        </Tooltip>
                      )}
                      {/* <Tooltip title="Copy post"> */}
                      <CopyToClipboard text={message} onCopy={() => setShowTooltip(message)}>
                        <AssignmentIcon
                          variant="contained"
                          fontSize="small"
                          className="link-feel"
                          onClick={() => {
                            setShowTooltip(message);
                            setTimeout(() => setShowTooltip(false), 1500);
                          }}
                        />
                      </CopyToClipboard>
                      {/* </Tooltip> */}
                      {network?.includes('Linkedln') && (
                        <LinkedInShareButton
                          post={m}
                          setShowSocialPost={setShowSocialPost}
                          linkedinTokenFlag={linkedinTokenFlag}
                        />
                      )}
                      {network?.includes('Facebook') && (
                        <FacebookButton
                          post={m}
                          setShowSocialPost={setShowSocialPost}
                          isAdmin={isAdminPage}
                        />
                      )}
                      {/* {(published && network?.includes('Instagram')) &&
                                            <InstagramShareButton post={m} setShowSocialPost={setShowSocialPost} />
                                        } */}
                      {network?.includes('Twitter') && (
                        <TwitterShareButton
                          post={m}
                          setShowSocialPost={setShowSocialPost}
                          isAdmin={isAdminPage}
                        />
                      )}
                      <Button onClick={() => showPostDetail(m)} size="small">
                        Details
                      </Button>
                    </div>
                  }
                </CardActions>
              </Card>
            </>
          );
        })}
      </Box>
    </Grid>
  );
};

const emailRowStyle = {
  margin: '1em 2em',
};
export const SOCIAL_NETWORK = [
  { label: 'Facebook', value: 'Facebook' },
  { label: 'Instagram', value: 'Instagram' },
  { label: 'Linkedln', value: 'Linkedln' },
  { label: 'Twitter', value: 'Twitter' },
];
const PostDetailsModal = ({
  show,
  setShow,
  showImagesModal,
  setStatus,
  setShowConfirmModal,
  confirmed,
  setConfirmed,
  messages,
  patchMessage,
  resetFlag,
  setResetFlag,
}) => {
  const [editFlag, setEditFlag] = useState(false);
  const user = useUser();
  const isContentManager = user.permissions.ContentManagement === true;
  const [casgUsers, setCasgUsers] = useState([]);
  const [imageData, setImageData] = useState();
  const [casgUsersMap, setCasgUsersMap] = useState({ 0: { id: 0, label: 'ALL', value: 0 } });
  const [selectedCategory, setCategory] = useState(show?.categoryId);
  const [selectedProduct, setSelectedProduct] = useState('');
  const [productNames, setProductNames] = useState();
  const [availableToAll, setAvailableToAll] = useState(false);
  const [deleteIndicator, setDeleteIndicator] = useState(false);
  const [action, setAction] = useState();
  const setApprovedMessages = useStore((state) => state.SET_APPROVED_MESSAGES);
  const setDraftMessages = useStore((state) => state.SET_DRAFT_MESSAGES);
  const {
    data: categories,
    isPending: isLoading,
    isError,
  } = useQuery({
    queryKey: ['GetSocialCategories'],
    queryFn: GetSocialCategories(),
  });
  const categoryOptions = categories?.map(({ id, category1 }) => ({ value: id, label: category1 }));

  useEffect(() => {
    if (confirmed && action) {
      if (availableToAll) {
        values.Users = 'ALL';
        values.UsersGuid = '';
      }

      if (deleteIndicator) {
        deletePost.mutate(
          { Post: values },
          {
            onSuccess: (data, variables) => {
              const updatedMessages = messages?.filter((m) => m.id !== variables.Post.id);
              if (variables.Post.published) {
                setApprovedMessages(updatedMessages);
              } else {
                setDraftMessages(updatedMessages);
              }
              reset('success', `Message deleted successfully`);
            },
            onError: () => {
              setStatus({
                show: true,
                status: 'error',
                successMsg: `Unable to delete message, please try later.`,
              });
            },
          }
        );
      } else if (action === 'publish' || action === 'unpublish') {
        const published = action === 'publish';
        patchMessage.mutate(
          {
            postsMedia: [{ PostId: values.id }],
            queries: [{ queryParam: 'published', queryVal: published }],
          },
          {
            onSuccess: (data, variables) => {
              if (data?.postsMedia?.length > 0) {
                resetImageOnPage(variables, data);
              }
              if (variables?.queries?.length > 0) {
                if (data.post.published) {
                  const { updatedDraftMessages, approvedMessages: am } =
                    updatePublishedMessagesInstore(data.post, draftMessages, approvedMessages);
                  setDraftMessages(updatedDraftMessages);
                  setApprovedMessages(am);
                } else {
                  const { updatedApprovedMessages, draftMessages: dm } = updateDraftMessagesInStore(
                    data,
                    draftMessages,
                    approvedMessages
                  );
                  setApprovedMessages(updatedApprovedMessages);
                  setDraftMessages(dm);
                }
              }
              setResetFlag(true);
            },
            onError: () => {
              setStatus({
                show: true,
                status: 'error',
                successMsg: `Unable to create message, please try later.`,
              });
            },
          }
        );
      } else {
        submitForm.mutate(
          { Post: values },
          {
            onSuccess: (data) => {
              for (var i = 0; i < messages.length; i++) {
                if (messages[i].id === data.id) {
                  messages[i] = data;
                  break;
                }
              }
              reset('success', `Message created successfully`);
            },
            onError: () => {
              setStatus({
                show: true,
                status: 'error',
                successMsg: `Unable to create message, please try later.`,
              });
            },
          }
        );
      } //Should output has true, because there is shouldnt be a scenario for creating published posts.
      setShowConfirmModal(false);
      setAction(undefined);
    }
  }, [confirmed]);

  useEffect(() => {
    setAvailableToAll(show?.users === 'ALL');
    if (show) {
      updateValues(show);
      const { postsMedia } = show;
      const image = postsMedia[0]?.image;
      const imagePath = image?.url;
      const imageBaseUrl = process.env.REACT_APP_EXTHUB_DOMAIN;
      if (imagePath) {
        /*const ext = imagePath.substring(imagePath.lastIndexOf(".") + 1)
                const getImageData = async () => {
                    const i = await GetImage(`AgentPortal\\SocialMedia${imagePath}`)();                
                    const idp = `data:image/${ext};base64,${i}`.replaceAll('"', "");
                    setImageData(idp);
                }
                getImageData()*/
        setImageData(`${imageBaseUrl}/api/cdn${imagePath}`);
      }
    }
  }, [show]);

  useEffect(() => {
    if (resetFlag) {
      reset();
    }
  }, [resetFlag]);

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ('Message' in fieldValues)
      temp.Message = fieldValues.Message ? '' : 'Message is a required field.';
    if ('CategoryID' in fieldValues)
      temp.CategoryID = fieldValues.CategoryID ? '' : 'Category is a required field.';
    if ('Title' in fieldValues) temp.Title = fieldValues.Title ? '' : 'Title is a required field.';
    if ('ProductID' in fieldValues)
      temp.ProductID = fieldValues.ProductID ? '' : 'Product is a required field.';

    setErrors({
      ...temp,
    });

    if (fieldValues == values) return Object.values(temp).every((x) => x == '');
  };

  const casgUsersQuery = useQuery({
    queryKey: ['GetAllCasgUsers'],
    queryFn: () => GetAllCasgUsers()()(),
  });

  useEffect(() => {
    if (casgUsersQuery.isSuccess && casgUsersQuery.data) {
      Promise.all([casgUsersQuery.data]).then(([k]) => {
        const users = Array.isArray(k) ? k : typeof k === 'string' ? JSON.parse(k) : k;
        users
          ?.map((element) => {
            element['label'] = element.displayName;
            element['value'] = element.id;
            if (casgUsersMap) {
              casgUsersMap[element.id] = element;
              setCasgUsersMap(casgUsersMap);
            }
            return element;
          })
          .sort((a, b) =>
            b.displayName < a.displayName ? -1 : b.displayName > a.displayName ? 1 : 0
          );

        setCasgUsers(users);
      });
    }
  }, [casgUsersQuery.isSuccess, casgUsersQuery.data]);

  const { values, errors, setErrors, handleDataChange, updateValues } = useForm({}, true, validate);

  const productNamesQuery = useQuery({
    queryKey: ['getProductNames', 0],
    queryFn: () => GetProductNames()(),
  });

  useEffect(() => {
    if (productNamesQuery.isSuccess && productNamesQuery.data) {
      const raw = productNamesQuery.data;
      const products = Array.isArray(raw) ? raw : typeof raw === 'string' ? JSON.parse(raw) : raw;
      const pn = products?.map(({ ProductId, Title }) => ({ value: ProductId, label: Title }));
      pn.push({ value: 'Other', label: 'Other' });
      pn.push({ value: 'N/A', label: 'N/A' });
      setProductNames(pn);
    }
  }, [productNamesQuery.isSuccess, productNamesQuery.data]);

  const casgUsersQuery2 = useQuery({
    queryKey: ['GetAllCasgUsers2'],
    queryFn: () => GetAllCasgUsers()()(),
  });

  useEffect(() => {
    if (casgUsersQuery2.isSuccess && casgUsersQuery2.data) {
      const source = Array.isArray(casgUsersQuery2.data)
        ? casgUsersQuery2.data
        : typeof casgUsersQuery2.data === 'string'
          ? JSON.parse(casgUsersQuery2.data)
          : casgUsersQuery2.data;
      const users = source
        .map((element) => ({
          ...element,
          label: element.displayName,
          value: element.id,
        }))
        .sort((a, b) =>
          b.displayName < a.displayName ? -1 : b.displayName > a.displayName ? 1 : 0
        );
      setCasgUsers(users);
    }
  }, [casgUsersQuery2.isSuccess, casgUsersQuery2.data]);

  const reset = (status = 'success', message = 'action successfull') => {
    resetState();
    setStatus({
      show: true,
      status: status,
      successMsg: message,
    });
  };

  const resetState = () => {
    setShow(false);
    setConfirmed(false);
    setResetFlag(false);
    setEditFlag(false);
    setDeleteIndicator(false);
  };

  const submitForm = useMutation({
    mutationFn: async (data) => {
      return await UpdateMessages(data)();
    },
  });

  const deletePost = useMutation({
    mutationFn: async ({ Post }) => {
      return await DeleteMessages(Post.id)();
    },
  });

  const handleClose = () => {
    resetState();
  };

  const handleSubmit = (action) => {
    setAction(action);
    if (validate()) {
      setShowConfirmModal(true);
    }
  };

  const handleImageUpdate = (network) => {
    show.networkToUpdate = network;
    showImagesModal(show);
  };

  return (
    <Dialog
      open={!!show}
      onClose={handleClose}
      disableEscapeKeyDown
      maxWidth="md"
      fullWidth
      PaperProps={{ className: 'pdf-modal' }}
    >
      <DialogTitle>
        {editFlag ? 'Edit Post' : show?.title}
        <IconButton onClick={handleClose} style={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      {!editFlag && (
        <>
          <DialogContent id="email-form-modal-body">
            <div>{show?.message}</div>
            <div className="detail-images">
              {show?.postsMedia?.map((pm) => {
                const { image, network, postID } = pm;
                return (
                  <div style={{ position: 'relative' }}>
                    <CardMedia
                      image={imageData} // require image
                      title={`${network} - ${image.name}`}
                      style={{
                        height: '150px',
                        width: '150px',
                        marginTop: '20px',
                      }} // specify styles
                    />
                    {isContentManager && (
                      <IconButton
                        onClick={() => handleImageUpdate(network)}
                        className="link-feel"
                        style={{
                          width: '35px',
                          height: '35px',
                          position: 'absolute',
                          bottom: '2px',
                          right: '2px',
                          backgroundColor: 'white',
                          fill: '#ADD8E6',
                          outline: 'none',
                        }}
                      >
                        <UpdateImage />
                      </IconButton>
                    )}
                  </div>
                );
              })}
            </div>
          </DialogContent>
        </>
      )}
      {editFlag && (
        <>
          <DialogContent id="email-form-modal-body">
            <div className="row" style={emailRowStyle}>
              <div className="col">
                <TextField
                  fullWidth={true}
                  variant="outlined"
                  id="outlined-multiline-static"
                  label="Title"
                  minRows={7}
                  value={values.Title || show?.title}
                  error={errors.Title}
                  helperText={errors.Title}
                  onChange={(e) => {
                    handleDataChange('Title', e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="row" style={emailRowStyle}>
              <div className="col">
                <TextField
                  fullWidth={true}
                  variant="outlined"
                  id="outlined-multiline-static"
                  label="Message"
                  multiline
                  minRows={7}
                  value={values.Message || show?.message}
                  error={errors.Message}
                  helperText={errors.Message}
                  onChange={(e) => {
                    handleDataChange('Message', e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="row" style={emailRowStyle}>
              <div className="col">
                <Dropdown
                  setValue={(category) => {
                    setCategory(category);
                    handleDataChange('CategoryID', category.value);
                  }}
                  selected={selectedCategory}
                  value={show?.categoryID}
                  error={errors.CategoryID}
                  id="category-select-label"
                  label="Category*"
                  options={categoryOptions}
                />
              </div>
            </div>
            <div className="row" style={emailRowStyle}>
              <div className="col">
                <MultipleSelect
                  setValue={(v) => {
                    handleDataChange('Network', v.join());
                  }}
                  selected={values.Network?.split(',') || show?.network?.split(',')}
                  error={errors.network}
                  id="network-select-label"
                  label="Social Channel"
                  options={SOCIAL_NETWORK}
                />
              </div>
            </div>
            <div className="row" style={emailRowStyle}>
              <div className="col">
                <Dropdown
                  setValue={(product) => {
                    setSelectedProduct(product);
                    handleDataChange('ProductID', product.value);
                  }}
                  selected={selectedProduct}
                  value={values?.ProductID || show?.productID}
                  error={errors.ProductID}
                  id="product-select-label"
                  label="Product"
                  options={productNames}
                />
              </div>
            </div>
            <div className="row" style={emailRowStyle}>
              <div className="col">
                <Box ml={2}>
                  <Tooltip title="Available to All" placement="top" arrow>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={availableToAll}
                          onClick={(e) => {
                            setAvailableToAll(e.target.checked);
                          }}
                          className="select-item"
                        />
                      }
                      label="Available to All"
                    />
                  </Tooltip>
                </Box>
                {!availableToAll && (
                  <Autocomplete
                    freeSolo
                    multiple
                    options={casgUsers || []}
                    getOptionLabel={(o) => o?.label || o}
                    onChange={(e, v) => {
                      // Users is the legacy int-bracket audience list (bli-native picks have no
                      // legacy id and are dropped here); UsersGuid is the GUID-bracket list — always
                      // present for every selected agent, bli-native or migrated. Preferred going
                      // forward per the dual-read design already in place on the read side
                      // (SocialsPostsController.GetMessages).
                      const users = v
                        .map((item) => item.id)
                        .filter((id) => id !== null && id !== undefined)
                        .join(',');
                      const usersGuid = v
                        .map((item) => item.userId)
                        .filter((id) => id !== null && id !== undefined)
                        .join(',');
                      handleDataChange('Users', users);
                      handleDataChange('UsersGuid', usersGuid);
                    }}
                    // onInputChange={(e, i) => { console.log(i) }}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => {
                        // console.log(option, index)
                        return (
                          <Chip
                            variant="outlined"
                            label={option.label || option}
                            {...getTagProps({ index })}
                          />
                        );
                      })
                    }
                    renderInput={(params) => (
                      <TextField
                        variant="outlined"
                        {...params}
                        onChange={(e) => {
                          handleUserTextChange(e.target.value);
                        }}
                        label="Users"
                      />
                    )}
                    id="tags-filled"
                  />
                )}
              </div>
            </div>
          </DialogContent>
        </>
      )}
      <DialogActions>
        {!editFlag && (
          <button className="btn" type="button" onClick={handleClose}>
            Close
          </button>
        )}
        {!editFlag && isContentManager && (
          <button
            className="btn btn-danger"
            color="error"
            type="button"
            onClick={() => {
              setDeleteIndicator(true);
              handleSubmit('delete');
            }}
          >
            Delete
          </button>
        )}
        {!show?.published && !editFlag && isContentManager && (
          <button className="btn btn-success" type="button" onClick={() => handleSubmit('publish')}>
            Publish
          </button>
        )}
        {show?.published && !editFlag && isContentManager && (
          <button
            className="btn btn-success"
            type="button"
            onClick={() => handleSubmit('unpublish')}
          >
            Unpublish
          </button>
        )}
        {isContentManager && !editFlag && (
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => {
              setEditFlag(true);
            }}
          >
            Edit
          </button>
        )}
        {isContentManager && editFlag && (
          <button
            className="btn btn-danger"
            type="button"
            onClick={() => {
              resetState();
            }}
          >
            Cancel Edit
          </button>
        )}
        {isContentManager && editFlag && (
          <button className="btn btn-success" type="button" onClick={() => handleSubmit('update')}>
            Submit
          </button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export const UpdateImageModal = ({
  show,
  setShow,
  setStatus,
  setShowConfirmModal,
  confirmed,
  setConfirmed,
  updateImage,
  resetFlag,
  setResetFlag,
}) => {
  const [chosenNetwork, chooseNetwork] = useState();
  const [networkDictionary, setNetworkDictionary] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [page, setPage] = useState(1);
  const [next, setNext] = useState(true);
  const [totalCount, setTotalCount] = useState();
  const [imageList, setImageList] = useState({
    Facebook: [],
    Twitter: [],
    Linkedln: [],
    Instagram: [],
  });
  const [imageSelected, setImageSelect] = useState([]);
  const user = useUser();
  const isContentManager = user.permissions.ContentManagement === true;
  const [editFlag, setEditFlag] = useState(false);

  const socialMediaFilesQuery = useQuery({
    queryKey: ['GetSocialMediaFiles', page, chosenNetwork],
    queryFn: GetSocialMediaFileList([
      { queryParam: 'page', queryVal: page },
      { queryParam: 'network', queryVal: chosenNetwork },
    ]),
    enabled: next && !!chosenNetwork && imageList[chosenNetwork]?.length === 0,
  });

  useEffect(() => {
    if (socialMediaFilesQuery.isSuccess && socialMediaFilesQuery.data) {
      const data = socialMediaFilesQuery.data;
      setNext(false);
      setTotalCount(data.totalCount);

      if (chosenNetwork) {
        imageList[chosenNetwork] = [...imageList[chosenNetwork], ...data.items];
        setImageList(imageList);
      }
    }
  }, [socialMediaFilesQuery.isSuccess, socialMediaFilesQuery.data]);

  useEffect(() => {
    if (confirmed && JSON.stringify(networkDictionary) !== '{}') {
      const keys = Object.keys(networkDictionary);
      const postsMedia = keys.map((i) => ({
        ImageId: networkDictionary[i],
        Network: i,
        PostId: show.id,
      }));
      updateImage.mutate({ postsMedia });
      setShowConfirmModal(false);
    }
  }, [confirmed]);

  useEffect(() => {
    if (resetFlag) {
      reset();
    }
  }, [resetFlag]);

  const reset = () => {
    setImageList({ Facebook: [], Twitter: [], Linkedln: [] });
    setCurrentPage(0);
    setConfirmed(false);
    setNetworkDictionary({});
    chooseNetwork(undefined);
    setImageList({ Facebook: [], Twitter: [], Linkedln: [], Instagram: [] });
    setImageSelect([]);
    setShow(null);
    setResetFlag(false);
  };

  const handleClose = () => {
    reset();
  };

  const handleSubmit = () => {
    if (Object.keys(networkDictionary).length > 0) {
      setShowConfirmModal(true);
    }
  };

  const images = (
    <div>
      <div className="image-table-container">
        <table className="vertical-table">
          <tr className="vertical-table-tab-container">
            <List className="link-text-container">
              {show?.network?.split(',')?.map((n) => {
                if (show?.networkToUpdate && show?.networkToUpdate !== n) {
                  return;
                }
                return (
                  <ListItem
                    id="link-text"
                    className={`${chosenNetwork === n ? 'opened' : ''}${imageSelected.includes(n) ? ' selected' : ' notselected'}`}
                    onClick={() => {
                      chooseNetwork(n);
                    }}
                  >
                    <p id={`link-text-${n}`}>{n}</p>
                  </ListItem>
                );
              })}
            </List>
          </tr>
          <td>
            {chosenNetwork && imageList[chosenNetwork] && (
              <>
                <List className="image-list-container">
                  {imageList[chosenNetwork]?.map(({ id, name, url }) => {
                    const isSelected = networkDictionary[chosenNetwork] === id;

                    return (
                      <ImageTile
                        key={`${name}${id}`}
                        id={id}
                        title={name}
                        imageUrl={url}
                        value={networkDictionary}
                        isSelected={isSelected}
                        handleCheckboxChange={() => {
                          setImageSelect([...imageSelected, chosenNetwork]);
                          setNetworkDictionary({ ...networkDictionary, [chosenNetwork]: id });
                        }}
                      />
                    );
                  })}
                </List>
              </>
            )}
          </td>
        </table>
        {chosenNetwork && !imageList[chosenNetwork] && (
          <div>No Images have been uploaded for {chosenNetwork}</div>
        )}
        {!chosenNetwork && (
          <div>Please select a social channel and then select and image for that channel</div>
        )}
      </div>
      {imageList[chosenNetwork]?.length != 0 &&
        totalCount > imageList[chosenNetwork]?.length &&
        !!chosenNetwork && (
          <Box
            display="block"
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            <Button
              onClick={() => {
                setPage(page + 1);
                setNext(true);
              }}
            >
              More Images
            </Button>
          </Box>
        )}
    </div>
  );

  return (
    <Dialog
      open={!!show}
      onClose={handleClose}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      PaperProps={{ className: 'custom-modal' }}
    >
      <DialogTitle>
        Update Post Media
        <IconButton onClick={handleClose} style={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent id="email-form-modal-body">{images}</DialogContent>
      <DialogActions>
        <button className="btn" type="button" onClick={handleClose}>
          Close
        </button>
        {!show?.published && isContentManager && (
          <button className="btn btn-success" type="button" onClick={handleSubmit}>
            Publish
          </button>
        )}
        {isContentManager && !editFlag && (
          <button
            className="btn btn-danger"
            type="button"
            onClick={() => {
              setEditFlag(true);
            }}
          >
            Edit
          </button>
        )}
        {isContentManager && editFlag && (
          <button
            className="btn btn-danger"
            type="button"
            onClick={() => {
              setEditFlag(false);
            }}
          >
            Cancel Edit
          </button>
        )}
        {isContentManager && editFlag && (
          <button className="btn btn-success" type="button" onClick={handleSubmit}>
            Submit
          </button>
        )}
      </DialogActions>
    </Dialog>
  );
};

const updatePublishedMessagesInstore = (data, draftMessages, approvedMessages) => {
  const updatedDraftMessages = draftMessages?.filter((m) => m.id !== data.id);
  approvedMessages.unshift(data);

  return { updatedDraftMessages, approvedMessages };
};

const updateDraftMessagesInStore = (data, draftMessages, approvedMessages) => {
  const updatedApprovedMessages = approvedMessages?.filter((m) => m.id !== data.post.id);
  draftMessages.unshift(data?.post || data);

  return { updatedApprovedMessages, draftMessages };
};

const limitStringWithEllipsis = (str, limit) => {
  if (str?.length > limit) {
    return str?.substring(0, limit) + '...';
  }
  return str;
};
